export const SUPPORTED_LOCALES = ["en", "fr", "ja", "es", "de"] as const;
export const DEFAULT_LOCALE = "en" as const;
export const LOCALE_COOKIE = "NEXT_LOCALE" as const;

// When true: full site-wide localisation (cookie-based, language switcher visible).
// When false/unset: direct-URL-only mode — locale is inferred from the URL path,
// the language switcher is hidden, and all generated links default to English paths.
export const LOCALE_SWITCHER_ENABLED =
  process.env.NEXT_PUBLIC_LOCALE_SWITCHER_ENABLED === "true";

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export function isValidLocale(value: string): value is Locale {
  return SUPPORTED_LOCALES.includes(value as Locale);
}

// Prerendered pages see their internal route path (e.g. "/en/blog/"), while
// English URLs are public without the prefix (e.g. "/blog/").
export function toPublicPathname(pathname: string): string {
  const prefix = `/${DEFAULT_LOCALE}`;
  if (pathname === prefix) return "/";
  return pathname.startsWith(`${prefix}/`)
    ? pathname.slice(prefix.length)
    : pathname;
}
